/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlateformeThemeDto } from './PlateformeThemeDto';
import {
    PlateformeThemeDtoFromJSON,
    PlateformeThemeDtoFromJSONTyped,
    PlateformeThemeDtoToJSON,
    PlateformeThemeDtoToJSONTyped,
} from './PlateformeThemeDto';

/**
 * 
 * @export
 * @interface PlateformeDto
 */
export interface PlateformeDto {
    /**
     * 
     * @type {string}
     * @memberof PlateformeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeDto
     */
    code: string;
    /**
     * 
     * @type {PlateformeThemeDto}
     * @memberof PlateformeDto
     */
    theme?: PlateformeThemeDto;
    /**
     * Nombre d'intermédiaires (courtiers) rattachés à la plateforme.
     * @type {number}
     * @memberof PlateformeDto
     */
    brokersCount?: number;
    /**
     * Nombre de tunnels actifs de la plateforme.
     * @type {number}
     * @memberof PlateformeDto
     */
    tunnelsCount?: number;
    /**
     * Mode de gestion : GEREE (la PM principale gouverne) ou ADMINISTREE (l'admin pilote, la PM principale n'est que titulaire).
     * @type {string}
     * @memberof PlateformeDto
     */
    modeGestion?: PlateformeDtoModeGestionEnum;
    /**
     * Désignation de la personne morale gérante.
     * @type {string}
     * @memberof PlateformeDto
     */
    gereeParNom?: string | null;
    /**
     * Libellé de la nature de la PM gérante (ex. Cabinet de courtage).
     * @type {string}
     * @memberof PlateformeDto
     */
    natureLabel?: string | null;
    /**
     * Libellé de la sous-nature de la PM gérante (ex. Grossiste), si elle en a une.
     * @type {string}
     * @memberof PlateformeDto
     */
    sousNatureLabel?: string | null;
}


/**
 * @export
 */
export const PlateformeDtoModeGestionEnum = {
    Geree: 'GEREE',
    Administree: 'ADMINISTREE'
} as const;
export type PlateformeDtoModeGestionEnum = typeof PlateformeDtoModeGestionEnum[keyof typeof PlateformeDtoModeGestionEnum];


/**
 * Check if a given object implements the PlateformeDto interface.
 */
export function instanceOfPlateformeDto(value: object): value is PlateformeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function PlateformeDtoFromJSON(json: any): PlateformeDto {
    return PlateformeDtoFromJSONTyped(json, false);
}

export function PlateformeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlateformeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'theme': json['theme'] == null ? undefined : PlateformeThemeDtoFromJSON(json['theme']),
        'brokersCount': json['brokersCount'] == null ? undefined : json['brokersCount'],
        'tunnelsCount': json['tunnelsCount'] == null ? undefined : json['tunnelsCount'],
        'modeGestion': json['modeGestion'] == null ? undefined : json['modeGestion'],
        'gereeParNom': json['gereeParNom'] == null ? undefined : json['gereeParNom'],
        'natureLabel': json['natureLabel'] == null ? undefined : json['natureLabel'],
        'sousNatureLabel': json['sousNatureLabel'] == null ? undefined : json['sousNatureLabel'],
    };
}

export function PlateformeDtoToJSON(json: any): PlateformeDto {
    return PlateformeDtoToJSONTyped(json, false);
}

export function PlateformeDtoToJSONTyped(value?: PlateformeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'theme': PlateformeThemeDtoToJSON(value['theme']),
        'brokersCount': value['brokersCount'],
        'tunnelsCount': value['tunnelsCount'],
        'modeGestion': value['modeGestion'],
        'gereeParNom': value['gereeParNom'],
        'natureLabel': value['natureLabel'],
        'sousNatureLabel': value['sousNatureLabel'],
    };
}

